import React from "react"
import Header from "./layout/Header.js"

export default ({ children }) => (
  <div>
    <Header />
    {children}
  </div>
)
